<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Entrance Tickets</ion-title>
    </div>
    <div class="form-container ion-padding-horizontal">
      <form [formGroup]="sightSeeingForm">
        <div>
          <table class="pricing-table">
            <thead>
              <tr>
                <th style="width: 200px;">Location</th>
                <th>Visiting Places*</th>
                <th style="width: 120px;">Cost*</th>
                <th style="width: 140px;">Services*</th>
                <th style="width: 50px;"></th>
              </tr>
            </thead>
            <tbody formArrayName="locations">
              <ng-container *ngFor="let location of getLocationsArray().controls; index as locationIndex" [formGroupName]="locationIndex">
                <tr>
                  <td [rowSpan]="getVisitingPlacesArray(locationIndex).length + 1">
                    <div class="location-item">
                      <div class="location">
                        <div class="input-container mb-0">
                          <div [ngClass]="{ 'invalid-input': location.get('locationName')?.invalid && location.get('locationName')?.touched }">
                            <select class="input" formControlName="locationName">
                              <option value="" hidden>Select Location</option>
                              <option *ngFor="let location of getAvailableLocations(locationIndex)" [value]="location">{{location}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <ng-container formArrayName="visitingPlaces">
                  <tr *ngFor="let visitingPlace of getVisitingPlacesArray(locationIndex).controls; index as placeIndex" [formGroupName]="placeIndex">
                    <td>
                      <div [ngClass]="{ 'invalid-input': visitingPlace.get('place')?.invalid && visitingPlace.get('place')?.touched }">
                        <input class="input" style="text-align: left !important;" placeholder="Type Here" formControlName="place">
                      </div>
                    </td>
                    <td>
                      <div [ngClass]="{ 'invalid-input': visitingPlace.get('cost')?.invalid && visitingPlace.get('cost')?.touched }">
                        <input appNumbersOnly class="input" placeholder="0" formControlName="cost">
                      </div>
                    </td>
                    <td>
                      <div>
                        <div class="d-flex align-items-center justify-content-center">
                          <p class="mb-0 service-label me-2" [ngClass]="visitingPlace.get('service')?.value ? 'text-success' : 'text-danger'">{{visitingPlace.get('service')?.value ? 'Included':'Excluded'}}</p>
                          <ion-toggle formControlName="service"></ion-toggle>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="">
                        <ion-button fill="clear" color="danger" class="table-action-btn" (click)="removeVisitingPlaces(locationIndex, placeIndex)" [disabled]="getVisitingPlacesArray(locationIndex).length <= 1">
                          <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                        </ion-button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-between">
                        <div>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addLocation()" *ngIf="getLocationsArray().length < destinationsArray.length && getLocationsArray().length-1 == locationIndex">
                            <ion-icon name="add-outline"></ion-icon> Add Location
                          </ion-button>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="removeLocation(locationIndex)" *ngIf="getLocationsArray().length > 1">
                            <ion-icon name="close-outline"></ion-icon> Remove Location
                          </ion-button>
                        </div>
                        <div>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addVisitingPlaces(locationIndex)">
                            <ion-icon name="add-outline"></ion-icon> Add Pax
                          </ion-button>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="removeAllVisitingPlaces(locationIndex)">
                            <ion-icon name="close-outline"></ion-icon> Clear Pax
                          </ion-button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </form>
    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" type="button" (click)="goPrevious()" *ngIf="leadId" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="!itineraryId || formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>


